__turbopack_context__.v({
  "actualPrice": "ProductPrice-module-scss-module__dokdja__actualPrice",
  "basePrice": "ProductPrice-module-scss-module__dokdja__basePrice",
  "hasCustomerGroupPrice": "ProductPrice-module-scss-module__dokdja__hasCustomerGroupPrice",
  "hasInCartDiscountTag": "ProductPrice-module-scss-module__dokdja__hasInCartDiscountTag",
  "infoIcon": "ProductPrice-module-scss-module__dokdja__infoIcon",
  "memberGroupLabel": "ProductPrice-module-scss-module__dokdja__memberGroupLabel",
  "priceContainer": "ProductPrice-module-scss-module__dokdja__priceContainer",
});
